module.exports = __webpack_public_path__ + "static/site-image-da2e1fce0d7770ddc14053556e126940.png";